import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { Redirect } from "@/components/Routing/Redirect";
import { RequireAuth } from "@/components/Routing/RequireAuth";
import { canManageEvents } from "@/helpers/permissions";
import { EventDetailsPage } from "@/modules/events/pages/event-details/EventDetailsPage";
import { CreateEventPage } from "@/modules/events/pages/event-editor/CreateEventPage";
import { EditEventPage } from "@/modules/events/pages/event-editor/EditEventPage";
import { canListEvents } from "@/modules/events/permissions";
import { routes } from "@/routes";

import { eventsRoutes } from "./routes";

export const eventsRoute = [
  {
    path: "",
    element: <Redirect to={routes.calendar.list} />,
  },
  {
    path: eventsRoutes.create,
    element: (
      <RequireAuth permission={canManageEvents}>
        <CreateEventPage />
      </RequireAuth>
    ),
  },
  {
    path: eventsRoutes.edit,
    element: (
      <RequireAuth permission={canManageEvents}>
        <EditEventPage />
      </RequireAuth>
    ),
  },
  {
    path: eventsRoutes.details,
    element: (
      <RequireAuth permission={canListEvents}>
        <EventDetailsPage />
      </RequireAuth>
    ),
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
